import { BaseContainerModel } from '../base-container.model';
import { bl_pgw_label_exts_RowClass, bl_pgw_label_hdr_RowClass } from '../../dbschema';

export class PgwLabelContainerModel extends BaseContainerModel {
  bl_pgw_label_hdr: bl_pgw_label_hdr_RowClass = new bl_pgw_label_hdr_RowClass();
  bl_pgw_label_exts: bl_pgw_label_exts_RowClass[] = [];
}

